export default "__VITE_ASSET__D4V88Sva__"